export default __webpack_public_path__ + "static/media/2.afa1669d.jpg";